






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { groupModule } from '@/store/modules/entities/group.module';
import GClassManagementGroupSetting from '@/views/GClassManagement/GClassManagementGroupSetting.vue';

@Component({
  name: 'GClassManagementGroupSettingModal',
  computed: {},
  components: {
    GClassManagementGroupSetting,
  },
  methods: {},
})
export default class GClassManagementGroupSettingModal extends mixins(GPageBase) {
  groupSettingReRenderKey: number = 0;

  mounted() {}

  get isShowGroupSettingModal(): boolean {
    return groupModule.groupModalProperty.isShowGroupsettingModal;
  }

  handleGroupSettingModalClose(): void {
    const schoolGroupSettingInfoOptions = {
      isShowGroupsettingModal: false,
      isGroupSettingsDataSubmitted: false,
    };
    groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
    this.forceRerenderGroupSettingComponent();
  }

  forceRerenderGroupSettingComponent(): void {
    this.groupSettingReRenderKey += 1;
  }
}
